function buildTrackFavorite({ created, trackId, uid }) {
  if (!created) throw new Error("Favorite created timestamp is required")
  if (trackId === undefined || trackId === null || trackId === "") {
    throw new Error("Favorite track ID is required")
  }
  if (!uid) throw new Error("Favorite user ID is required")

  return {
    created,
    trackId: String(trackId),
    uid,
  }
}

module.exports = { buildTrackFavorite }
